import React from 'react';
import lightening from '../../Assets/lightening.svg';
import tick from '../../Assets/greenTick.svg';
import { Link } from 'react-router-dom';

const Pricing = () => {
	const benefits = [
		{ text: 'Free 50 first deliveries' },
		{ text: '10% transaction fee of all deliveries' },
		{ text: 'Lorem ipsum' },
		// { text: 'Lorem ipsum' },
		// { text: 'Lorem ipsum' },
		// { text: 'Lorem ipsum' },
	];
	return (
		<section id='price' className='my-5 text-center mx-auto'>
			<div className='fw-bold fs-2 mb-2'>Pricing</div>
			<div
				className='card text-start'
				style={{
					width: '80vw',
					maxWidth: '30rem',
					margin: '0 auto',
				}}
			>
				<div className='card-body'>
					<div className='d-flex align-items-center'>
						<span
							className=''
							style={{
								marginRight: '1rem',
								// marginBottom: '10rem',
							}}
						>
							<img alt='lightening' src={lightening} />
						</span>
						<span className='fs-5 fw-bold pt-1'>
							Setup Fee
						</span>
					</div>
					<div
						className='mt-1'
						style={{ opacity: '0.8', fontSize: '0.9rem' }}
					>
						The perfect plan for you
					</div>
					<div>
						<div className='fs-2 fw-bold mt-4'>
							NGN 50,000
						</div>
						<div
							style={{
								opacity: '0.8',
								fontSize: '0.9rem',
							}}
						>
							One time payment
						</div>
						<Link to='/signup'>
							<button
								className='btn btn-lg text-white fs-6 my-3 w-100'
								type='button'
								onClick={() => {
									window.scrollTo({
										left: 0,
										top: 0,
										behavior: 'smooth',
									});
								}}
								style={{ background: '#28B672' }}
							>
								Get Started
							</button>
						</Link>
					</div>
					<div>
						<div className='my-4 fw-bold'>BENEFITS:</div>
						<ul>
							{benefits.map((benefit) => {
								return (
									<li
										key={benefit.text}
										style={{
											listStyleImage: `url(${tick})`,
										}}
										className='mt-2'
									>
										{benefit.text}
									</li>
								);
							})}
						</ul>
					</div>
				</div>
			</div>
		</section>
	);
};

export default Pricing;
